img {
  transition-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  vertical-align: middle;
}
